
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M0 .732c.003.043.003.054.01.096a.71.71 0 00.197.38l4.25 4.251c.032.03.04.038.074.064a.71.71 0 00.856 0c.034-.026.041-.035.072-.064l4.25-4.25c.03-.032.038-.039.064-.073A.71.71 0 009.85.404a.714.714 0 00-.854-.371.71.71 0 00-.214.11c-.034.026-.042.035-.073.064l-3.75 3.75L1.21.206 1.174.174C1.14.147 1.133.139 1.097.116A.71.71 0 00.01.588C.003.63.003.64 0 .684v.048z","fill":"currentColor"}})])
          )
        }
      }
    